const festivaTranslations = new Map([
  ['Availability', 'Disponibilidad'],
  ['Price', 'Precio'],
  ['Red', 'Rojo'],
  ['Pink', 'Rosado'],
  ['White', 'Blanco'],
  ['Black', 'Negro'],
  ['Blue', 'Azul'],
  ['Purple', 'Lila'],
  ['Sort by:', 'Ordenar por:']
]);

function translateFestiva(root = document) {
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  const nodes = [];
  while (walker.nextNode()) nodes.push(walker.currentNode);
  nodes.forEach((node) => {
    const clean = node.nodeValue.trim();
    if (festivaTranslations.has(clean)) {
      node.nodeValue = node.nodeValue.replace(clean, festivaTranslations.get(clean));
    }
  });
}

translateFestiva();

new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType === Node.ELEMENT_NODE) translateFestiva(node);
    });
  });
}).observe(document.documentElement, { childList: true, subtree: true });


/* FESTIVA CONVERSION MOBILE — 2026-09-25 */
(function improveFestivaConversion() {
  function install() {
    if (!document.querySelector('.fv-mobile-buybar')) {
      const bar = document.createElement('nav');
      bar.className = 'fv-mobile-buybar';
      bar.setAttribute('aria-label', 'Compra rápida');
      bar.innerHTML = '<a href="/collections/halloween">Halloween</a><a href="/collections/halloween-camisetas">Camisetas</a><a href="/cart">Carrito</a>';
      document.body.appendChild(bar);
    }

    if (document.body.matches('[class*="template-product"], [data-template*="product"]') || document.querySelector('form[action*="/cart/add"]')) {
      const form = document.querySelector('form[action*="/cart/add"]');
      if (form && !document.querySelector('.fv-product-trust')) {
        const trust = document.createElement('div');
        trust.className = 'fv-product-trust';
        trust.innerHTML = '<span>Envíos a toda Colombia</span><span>Selecciona talla y color antes de agregar</span><span>Confirmación de tu pedido por WhatsApp</span>';
        form.insertAdjacentElement('afterend', trust);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', install, { once: true });
  } else {
    install();
  }
})();
